var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "label-resumo" }, [
      _vm._v("\n    Resumo da compra\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "margin-top": "10px", "font-size": "13px" } }, [
      _c("div", { staticClass: "preco-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticStyle: { width: "50%", "text-align": "right" } }, [
          _c("span", [_vm._v(_vm._s(_vm.formatMoney(_vm.total)))]),
        ]),
      ]),
      _vm._v(" "),
      _vm.cobrarTaxa
        ? _c("div", { staticClass: "preco-container" }, [
            _c("div", { staticStyle: { width: "49%", position: "relative" } }, [
              _c("strong", { staticStyle: { color: "#464646" } }, [
                _vm._v("Taxas"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tooltip,
                      expression: "tooltip",
                    },
                  ],
                  staticClass: "tooltip-container",
                },
                [
                  _c("span", { staticClass: "tooltip-text" }, [
                    _vm._v("\n            As taxas incluem\n            "),
                    _c("strong", [_vm._v(_vm._s(_vm.formatMoney(_vm.taxa)))]),
                    _vm._v(
                      "\n            de serviço, para manutenção da plataforma e operação.\n          "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "info-container ml-1 mr-1",
                  on: {
                    mouseenter: function ($event) {
                      _vm.tooltip = true
                    },
                    mouseleave: function ($event) {
                      _vm.tooltip = false
                    },
                  },
                },
                [_vm._m(1)]
              ),
              _vm._v(" "),
              _c("strong", [_vm._v(":")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { width: "50%", "text-align": "right" } },
              [_c("span", [_vm._v(_vm._s(_vm.formatMoney(_vm.taxa)))])]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "preco-container" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticStyle: { width: "50%", "text-align": "right" } }, [
          _c("span", [_vm._v(_vm._s(_vm.formatMoney(_vm.opcionais)))]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.desconto > 0,
              expression: "desconto > 0",
            },
          ],
          staticClass: "preco-container",
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "50%", "text-align": "right" } }, [
            _c("span", [_vm._v("-" + _vm._s(_vm.formatMoney(_vm.desconto)))]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "49%" } }, [
      _c("strong", { staticStyle: { color: "#464646" } }, [
        _vm._v("Valor da reserva:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [
      _c("i", {
        staticClass: "fas fa-question",
        staticStyle: { padding: "3px", color: "#fff" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "49%" } }, [
      _c("strong", { staticStyle: { color: "#464646" } }, [
        _vm._v("Opcionais:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "49%" } }, [
      _c("strong", { staticStyle: { color: "#464646" } }, [
        _vm._v("Desconto do período:"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }